<script lang="ts">
  import SourceCleanupInstructionTags from "../../../../../../../../_shared/_modules/source-cleanup-instruction-tags"
  import type { SourceCleanupInstructionPresentation } from "../../../../../../../../_shared/_logic/source-cleanup-instruction-tags"

  let {
    instructions = [],
    disabled = false,
  }: {
    instructions?: SourceCleanupInstructionPresentation[]
    disabled?: boolean
  } = $props()
</script>

<SourceCleanupInstructionTags {instructions} muted={disabled} />
